module.exports = __webpack_public_path__ + "img/music-player-fill.36288863.svg";